import * as React from "react";
import TextField from "@mui/material/TextField";
import { alpha, styled } from "@mui/material/styles";
import Autocomplete from "@mui/material/Autocomplete";
import _ from "lodash";
import { useTranslation } from "react-i18next";
import Compdirection from "../themes/CompDirection";
import "./DepartmentBox.css";
import { themes } from '../themes/themes';

const DepartmentBox = (props: any) => {
  const [departmentName, setDepartmentName] = React.useState("");
  const [departmentId, setDepartmentId] = React.useState("");
  const { t } = useTranslation();
  const trans: any = t;
  const CustomAutocomplete = styled(Autocomplete)({
    "& label.Mui-focused": {
      color:themes.primary,
      borderRadius: "8px",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: themes.primary,
      borderRadius: "8px",
    },
  });
  const handleChange = (deptName: any) => {
    const c = _.filter(props.allDepartments, function (o) {
      return o.name === deptName;
    });
    let id ;
    if (c.length) {
      const cnty = c[0];
      id = cnty.id;
      setDepartmentId(cnty.id);
      setDepartmentName(deptName);
    }
    if (deptName) {
      props.selectedDepartments(id);
    } else {
      setDepartmentName("");
      props.selectedDepartments("");
    }
  };

  return (
    <Compdirection>
      <CustomAutocomplete
        onChange={(event, newValue) => {
          handleChange(newValue);
        }}
        value={departmentName}
        options={_.map(props.allDepartments, (dept) => {
          return dept.name;
        })}
        size="medium"
        disablePortal
        id="combo-box-demo"
        sx={{ width: 260, color: "#0000001F" }}
        renderInput={(params) => (
          <TextField
            style={{
              fontFamily: "Lato",
              fontSize: "0.7em",
            }}
            {...params}
            label={trans("Department")}
          />
        )}
      />
    </Compdirection>
  );
};
export default DepartmentBox;
